// disabling eslint temporarily for legacy files until they can be refactored
/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import Select, { components } from "react-select";
import { Col, Button, Form, Row, Spinner, ButtonGroup } from "react-bootstrap";
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";
import { multiSelectStyle } from "../../../styles/styles";
import ScrollMenu from "../../Scrolls/ScrollMenu";
import { sortingCarets } from "../utils";
import { GeneralError } from "../../Errors/GeneralError";
import {
  Portlet,
  PortletBody,
} from "../../../../components/GenericPortlet/Portlet";
import language from "../../../utils/en.json";

export function PreventedIncidentsTable(props) {
  const {
    isError,
    isLoading: isParentLoading,
    tableData,
    onPageChange,
    onSizePerPageChange,
    sizePerPageList,
    keyField,
    showPagination,
    componentIsForPdf,
  } = props;

  const [isLoading, setLoading] = useState(true);
  const [filteredTableData, setFilteredTableData] = useState([]);

  const [showTypeMenu, setShowTypeMenu] = useState(false);
  const [showUserImpactedMenu, setShowUserImpactedMenu] = useState(false);
  const [showActionMenu, setShowActionMenu] = useState(false);
  const [showLocationMenu, setShowLocationMenu] = useState(false);

  const typeRef = useRef();
  const userImpactedRef = useRef();
  const actionRef = useRef();
  const locationRef = useRef();

  const [typeOptions, setTypeOptions] = useState([]);
  const [userImpactedOptions, setUserImpactedOptions] = useState([]);
  const [actionOptions, setActionOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);

  const [typeSelectedOptions, setTypeSelectedOptions] = useState([]);
  const [userImpactedSelectedOptions, setUserImpactedSelectedOptions] =
    useState([]);
  const [actionSelectedOptions, setActionSelectedOptions] = useState([]);
  const [locationSelectedOptions, setLocationSelectedOptions] = useState([]);

  const [numPerPage, setNumPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableSort, setTableSort] = useState("asc");

  // Handles setting the data list to be the correct filtered list
  useEffect(() => {
    if (tableData?.length) {
      const updatedFilteredTableData = filterTable(tableData);
      setFilteredTableData(updatedFilteredTableData);
    }
  }, [
    typeSelectedOptions,
    userImpactedSelectedOptions,
    actionSelectedOptions,
    locationSelectedOptions,
  ]); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (page) => {
    setCurrentPage(page);
    document.getElementById("preventedIncidentsTable").scrollIntoView();
  };

  const handleSizePerPageChange = (sizePerPage) => {
    setNumPerPage(sizePerPage);
    setCurrentPage(1);
    document.getElementById("preventedIncidentsTable").scrollIntoView();
  };

  const defaultSizePerPageList = [
    {
      text: "10",
      value: 10,
    },
    {
      text: "25",
      value: 25,
    },
    {
      text: "50",
      value: 50,
    },
    {
      text: "100",
      value: 100,
    },
  ];

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    formatRiskDetectionTableData();
    setFilteredTableData(tableData);
  }, [tableData]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatRiskDetectionTableData = async () => {
    setLoading(true);

    let typeData = [];
    let userImpactedData = [];
    let actionData = [];
    let locationData = [];

    for (let i = 0; i < tableData?.length; i++) {
      const preventedIncidentsTableData = tableData[i];

      if (preventedIncidentsTableData?.type) {
        typeData.push({
          value: preventedIncidentsTableData.type,
          label: preventedIncidentsTableData.type,
        });
      }
      if (preventedIncidentsTableData?.userImpacted) {
        userImpactedData.push({
          value: preventedIncidentsTableData.userImpacted,
          label: preventedIncidentsTableData.userImpacted,
        });
      }
      if (preventedIncidentsTableData?.action) {
        actionData.push({
          value: preventedIncidentsTableData.action,
          label: preventedIncidentsTableData.action,
        });
      }
      if (preventedIncidentsTableData?.location) {
        locationData.push({
          value: preventedIncidentsTableData.location,
          label: preventedIncidentsTableData.location,
        });
      }
    }

    const typeMap = new Map();
    for (const typeObject of typeData) {
      const typeCount = typeMap.get(typeObject.label);

      if (typeCount !== undefined) {
        typeMap.set(typeObject.label, typeCount + 1);
      } else {
        typeMap.set(typeObject.label, 1);
      }
    }
    for (const typeObject of typeData) {
      typeObject.count = typeMap.get(typeObject.label);
    }

    const userImpactedMap = new Map();
    for (const userImpactedObject of userImpactedData) {
      const count = userImpactedMap.get(userImpactedObject.label);

      if (count !== undefined) {
        userImpactedMap.set(userImpactedObject.label, count + 1);
      } else {
        userImpactedMap.set(userImpactedObject.label, 1);
      }
    }
    for (const userImpactedObject of userImpactedData) {
      userImpactedObject.count = userImpactedMap.get(userImpactedObject.label);
    }

    const actionMap = new Map();
    for (const actionObject of actionData) {
      const count = actionMap.get(actionObject.label);

      if (count !== undefined) {
        actionMap.set(actionObject.label, count + 1);
      } else {
        actionMap.set(actionObject.label, 1);
      }
    }
    for (const actionObject of actionData) {
      actionObject.count = actionMap.get(actionObject.label);
    }

    const locationMap = new Map();
    for (const locationObject of locationData) {
      const count = locationMap.get(locationObject.label);

      if (count !== undefined) {
        locationMap.set(locationObject.label, count + 1);
      } else {
        locationMap.set(locationObject.label, 1);
      }
    }
    for (const locationObject of locationData) {
      locationObject.count = locationMap.get(locationObject.label);
    }

    // Sort by name and remove duplicates
    typeData = typeData.filter(
      (v, i, a) => a.findIndex((t) => t.label === v.label) === i
    );
    typeData.sort((a, b) => a.label?.localeCompare(b.label));
    setTypeOptions(typeData);

    userImpactedData = userImpactedData.filter(
      (v, i, a) => a.findIndex((t) => t.label === v.label) === i
    );
    userImpactedData.sort((a, b) => a.label?.localeCompare(b.label));
    setUserImpactedOptions(userImpactedData);

    actionData = actionData.filter(
      (v, i, a) => a.findIndex((t) => t.label === v.label) === i
    );
    actionData.sort((a, b) => a.label?.localeCompare(b.label));
    setActionOptions(actionData);

    locationData = locationData.filter(
      (v, i, a) => a.findIndex((t) => t.label === v.label) === i
    );
    locationData.sort((a, b) => a.label?.localeCompare(b.label));
    setLocationOptions(locationData);

    setLoading(false);
  };

  const filterTable = (dataToFilter) => {
    const filterHelper = (field, filterOptions) => {
      if (filterOptions?.length) {
        dataToFilter = dataToFilter.filter((dataObject) =>
          filterOptions.some(
            (option) => option.value === dataObject[`${field}`]
          )
        );
      }
    };

    filterHelper("type", typeSelectedOptions);
    filterHelper("userImpacted", userImpactedSelectedOptions);
    filterHelper("action", actionSelectedOptions);
    filterHelper("location", locationSelectedOptions);
    return dataToFilter;
  };

  const updateFilter = (filterType, selectedFilterValueArray) => {
    switch (filterType) {
      case "type":
        if (selectedFilterValueArray?.length) {
          setTypeSelectedOptions(selectedFilterValueArray);
        } else {
          setTypeSelectedOptions([]);
        }
        break;
      case "userImpacted":
        if (selectedFilterValueArray?.length) {
          setUserImpactedSelectedOptions(selectedFilterValueArray);
        } else {
          setUserImpactedSelectedOptions([]);
        }
        break;
      case "action":
        if (selectedFilterValueArray?.length) {
          setActionSelectedOptions(selectedFilterValueArray);
        } else {
          setActionSelectedOptions([]);
        }
        break;
      case "location":
        if (selectedFilterValueArray?.length) {
          setLocationSelectedOptions(selectedFilterValueArray);
        } else {
          setLocationSelectedOptions([]);
        }
        break;
      default:
        break;
    }
  };

  function ValueContainer({ children, getValue, ...props }) {
    const { length } = getValue();
    return (
      <components.ValueContainer {...props}>
        {length === 1 && (
          <>
            <span className="multi-select-value">
              {props.selectProps.value[0].label}
            </span>
            <ClearIndicator {...props} />
          </>
        )}
        {length > 1 && (
          <>
            <span className="multi-select-value">{length}</span>
            <ClearIndicator {...props} />
            <components.Placeholder {...props} className="multi-select-label">
              {props.selectProps.placeholder}
            </components.Placeholder>
          </>
        )}
      </components.ValueContainer>
    );
  }

  function ClearIndicator({ innerRef, children, ...props }) {
    const onClear = (e) => {
      if (props.selectProps?.name === "type") {
        updateFilter("type", undefined);
      }
      if (props.selectProps?.name === "userImpacted") {
        updateFilter("userImpacted", undefined);
      }
      if (props.selectProps?.name === "action") {
        updateFilter("action", undefined);
      }
      if (props.selectProps?.name === "location") {
        updateFilter("location", undefined);
      }

      e.stopPropagation();
      e.preventDefault();
    };

    return (
      <div ref={innerRef} className="multi-select-clear" onClick={onClear}>
        <components.ClearIndicator {...props}>
          <span className="icon-xs flaticon2-cross p-2" />
        </components.ClearIndicator>
      </div>
    );
  }

  function Option({ children, ...props }) {
    const { isSelected, label, value, isMulti, data } = props;

    const onClick = (e) => {
      props.selectOption({ ...data });
      e.stopPropagation();
      e.preventDefault();
    };

    if (isMulti) {
      return (
        <components.Option {...props}>
          <div className="multi-select-option" onClick={onClick}>
            <Form.Check
              custom
              readOnly
              className="multi-select-check"
              checked={isSelected}
              label={label}
              value={value}
            />
            <span className="multi-select-count">{props.data.count}</span>
          </div>
        </components.Option>
      );
    }
  }

  const translateAction = (actionType) => {
    if (actionType === "remediated") return "Remediated";
    if (actionType === "dismissed") return "Dismissed";
    if (actionType === "confirmedCompromised") return "Confirmed Compromised";
    if (actionType === "confirmedSafe") return "Confirmed Safe";
    if (actionType === "unknown") return "Unknown";
    if (actionType === "none") return "None";
    return "Unknown";
  };

  // Security Check: Click handler for multi-select menus (workaround)
  const handleClick = (target, event) => {
    if (target === "type") {
      if (showTypeMenu) {
        setShowTypeMenu(false);
        if (typeRef?.current?.select?.inputRef) {
          typeRef.current.select.inputRef.blur();
        }
      } else {
        setShowTypeMenu(true);
      }
    }
    if (target === "userImpacted") {
      if (showUserImpactedMenu) {
        setShowUserImpactedMenu(false);
        if (userImpactedRef?.current?.select?.inputRef) {
          userImpactedRef.current.select.inputRef.blur();
        }
      } else {
        setShowUserImpactedMenu(true);
      }
    }
    if (target === "action") {
      if (showActionMenu) {
        setShowActionMenu(false);
        if (actionRef?.current?.select?.inputRef) {
          actionRef.current.select.inputRef.blur();
        }
      } else {
        setShowActionMenu(true);
      }
    }
    if (target === "location") {
      if (showLocationMenu) {
        setShowLocationMenu(false);
        if (locationRef?.current?.select?.inputRef) {
          locationRef.current.select.inputRef.blur();
        }
      } else {
        setShowLocationMenu(true);
      }
    }
  };

  // Outside click handler for hiding multi-select menus (workaround due to closeMenuOnSelect being disabled)
  const handleClickOutside = (event) => {
    if (
      typeRef.current &&
      !typeRef.current.select.controlRef.contains(event.target) &&
      !typeRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowTypeMenu(false);
      if (typeRef.current.select.inputRef) {
        typeRef.current.select.inputRef.blur();
      }
    }
    if (
      userImpactedRef.current &&
      !userImpactedRef.current.select.controlRef.contains(event.target) &&
      !userImpactedRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowUserImpactedMenu(false);
      if (userImpactedRef.current.select.inputRef) {
        userImpactedRef.current.select.inputRef.blur();
      }
    }
    if (
      actionRef.current &&
      !actionRef.current.select.controlRef.contains(event.target) &&
      !actionRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowActionMenu(false);
      if (actionRef.current.select.inputRef) {
        actionRef.current.select.inputRef.blur();
      }
    }
    if (
      locationRef.current &&
      !locationRef.current.select.controlRef.contains(event.target) &&
      !locationRef.current.select?.focusedOptionRef?.contains(event.target)
    ) {
      setShowLocationMenu(false);
      if (locationRef.current.select.inputRef) {
        locationRef.current.select.inputRef.blur();
      }
    }
  };

  const formatTypeColumn = (cell, row) => <span>{row.type}</span>;
  const formatUserImpactedColumn = (cell, row) => (
    <span>{row.userImpacted}</span>
  );
  const formatRiskStateColumn = (cell, row) => (
    <span>{`${
      row.category.charAt(0).toUpperCase() + row.category.slice(1)
    } - ${translateAction(row.action)}`}</span>
  );
  const formatLocationColumn = (cell, row) => <span>{row.location}</span>;
  const formatDateColumn = (cell, row) => <span>{row.date}</span>;

  const formatPDFTableHeader = (text) => (
    <span className="tableHeaderPdf">{text}</span>
  );

  const formatTypeHeader = () => {
    const text = "Incident Type";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div className="select-container" onClick={(e) => handleClick("type", e)}>
        <Select
          id="type"
          ref={typeRef}
          autoBlur
          name="type"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showTypeMenu}
          options={typeOptions}
          value={typeSelectedOptions}
          onChange={(value) => updateFilter("type", value)}
          placeholder="Incident Type"
          isClearable={false}
          isSearchable
          components={
            typeSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatUserImpactedHeader = () => {
    const text = "User Impacted";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("userImpacted", e)}
      >
        <Select
          id="userImpacted"
          ref={userImpactedRef}
          autoBlur
          name="userImpacted"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showUserImpactedMenu}
          options={userImpactedOptions}
          value={userImpactedSelectedOptions}
          onChange={(value) => updateFilter("userImpacted", value)}
          placeholder="User Impacted"
          isClearable={false}
          isSearchable
          components={
            userImpactedSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatDateHeader = () => {
    const text = "Date";
    return formatPDFTableHeader(text);
  };

  const formatRiskStateHeader = () => {
    const text = "Risk State";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("action", e)}
      >
        <Select
          id="action"
          ref={actionRef}
          autoBlur
          name="action"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showActionMenu}
          options={actionOptions}
          value={actionSelectedOptions}
          onChange={(value) => updateFilter("action", value)}
          placeholder="Risk State"
          isClearable={false}
          isSearchable
          components={
            actionSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const formatLocationHeader = () => {
    const text = "Location";
    if (componentIsForPdf) {
      return formatPDFTableHeader(text);
    }

    return (
      <div
        className="select-container"
        onClick={(e) => handleClick("location", e)}
      >
        <Select
          id="location"
          ref={locationRef}
          autoBlur
          name="location"
          classNamePrefix="multi-select"
          styles={multiSelectStyle}
          isMulti
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          menuIsOpen={showLocationMenu}
          options={locationOptions}
          value={locationSelectedOptions}
          onChange={(value) => updateFilter("location", value)}
          placeholder="Location"
          isClearable={false}
          isSearchable
          components={
            locationSelectedOptions?.length
              ? { MenuList: ScrollMenu, ClearIndicator, Option, ValueContainer }
              : { MenuList: ScrollMenu, Option }
          }
        />
      </div>
    );
  };

  const columns = [
    {
      dataField: "id",
      hidden: true,
    },
    {
      dataField: "type",
      text: "Incident Type",
      formatter: formatTypeColumn,
      headerFormatter: formatTypeHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "userImpacted",
      text: "User Impacted",
      formatter: formatUserImpactedColumn,
      headerFormatter: formatUserImpactedHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "riskState",
      text: "Risk State",
      formatter: formatRiskStateColumn,
      headerFormatter: formatRiskStateHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "location",
      text: "Location",
      formatter: formatLocationColumn,
      headerFormatter: formatLocationHeader,
      headerClasses: "selectable",
      sort: false,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
    {
      dataField: "date",
      text: "Date",
      formatter: formatDateColumn,
      headerFormatter: componentIsForPdf ? formatDateHeader : null,
      onSort: () => setTableSort(tableSort === "desc" ? "asc" : "desc"),
      sort: true,
      sortCaret: componentIsForPdf
        ? null
        : (order, column) => sortingCarets(order, column),
      title: true,
    },
  ];

  return (
    <div id="preventedIncidentsTable">
      <Row>
        <Col sm="12" md="12" lg="12" xl="12">
          {isLoading ? (
            <Portlet
              fluidHeight={false}
              className="portlet--border-bottom-dark"
            >
              <PortletBody fluid style={{ padding: 0 }}>
                <>
                  <Spinner />
                </>
              </PortletBody>
            </Portlet>
          ) : showPagination ? (
            <PaginationProvider
              pagination={paginationFactory({
                custom: true,
                page: currentPage,
                totalSize:
                  filteredTableData && filteredTableData.length
                    ? filteredTableData.length
                    : 0,
                sizePerPage: numPerPage,
                onPageChange: onPageChange || handlePageChange,
                onSizePerPageChange:
                  onSizePerPageChange || handleSizePerPageChange,
                sizePerPageList: sizePerPageList || defaultSizePerPageList,
              })}
            >
              {({ paginationProps, paginationTableProps }) => (
                <ToolkitProvider
                  keyField="id"
                  data={filteredTableData}
                  columns={columns}
                >
                  {(props) => (
                    <Row>
                      <Col md="12">
                        <BootstrapTable
                          {...props.baseProps}
                          keyField={keyField}
                          loading={isLoading}
                          filter={filterFactory()}
                          bordered={false}
                          hover={!!(!isLoading && filteredTableData?.length)}
                          bootstrap4
                          sort={{
                            dataField: "date",
                            order: tableSort,
                          }}
                          noDataIndication={
                            isError ? (
                              <GeneralError />
                            ) : isLoading ? (
                              <Spinner />
                            ) : (
                              <div className="no-data">
                                {language["GENERAL.NO_DATA"]}
                              </div>
                            )
                          }
                          {...paginationTableProps}
                        />
                        {filteredTableData?.length > 10 && (
                          <div className="pagination">
                            <div>
                              <ButtonGroup>
                                {paginationProps.sizePerPageList.map(
                                  (option) => (
                                    <Button
                                      key={option.text}
                                      onClick={() =>
                                        handleSizePerPageChange(option.value)
                                      }
                                      variant={
                                        numPerPage === option.value
                                          ? "primary"
                                          : "light"
                                      }
                                    >
                                      {option.text}
                                    </Button>
                                  )
                                )}
                              </ButtonGroup>
                            </div>
                            <div>
                              <PaginationListStandalone {...paginationProps} />
                            </div>
                          </div>
                        )}
                      </Col>
                    </Row>
                  )}
                </ToolkitProvider>
              )}
            </PaginationProvider>
          ) : (
            <ToolkitProvider
              keyField="id"
              data={filteredTableData}
              columns={columns}
            >
              {(props) => (
                <Row>
                  <Col md="12">
                    <BootstrapTable
                      {...props.baseProps}
                      keyField={keyField}
                      loading={isLoading}
                      filter={filterFactory()}
                      bordered={false}
                      hover={!!(!isLoading && filteredTableData?.length)}
                      bootstrap4
                      sort={{
                        dataField: "date",
                        order: tableSort,
                      }}
                      noDataIndication={
                        isError ? (
                          <GeneralError />
                        ) : isLoading ? (
                          <Spinner />
                        ) : (
                          <div className="no-data">
                            {language["GENERAL.NO_DATA"]}
                          </div>
                        )
                      }
                    />
                  </Col>
                </Row>
              )}
            </ToolkitProvider>
          )}
        </Col>
      </Row>
    </div>
  );
}
